import { getTenantCode } from '@/utils'
const tenantCode = getTenantCode()

/**
 * @description 获取token
 * @returns {string|ActiveX.IXMLDOMNode|Promise<any>|any|IDBRequest<any>|MediaKeyStatus|FormDataEntryValue|Function|Promise<Credential | null>}
 */
export function getToken() {
  // if (storage) {
  //   if ('localStorage' === storage) {
  //     return localStorage.getItem(tokenTableName)
  //   } else if ('sessionStorage' === storage) {
  //     return sessionStorage.getItem(tokenTableName)
  //   } else {
  //     return localStorage.getItem(tokenTableName)
  //   }
  // } else {
  return localStorage.getItem(`${tenantCode}_token`)
  // }
}

/**
 * @description 存储token
 * @param token
 * @returns {void|*}
 */
export function setToken(token) {
  // if (storage) {
  //   if ('localStorage' === storage) {
  //     return localStorage.setItem(tokenTableName, token)
  //   } else if ('sessionStorage' === storage) {
  //     return sessionStorage.setItem(tokenTableName, token)
  //   } else {
  //     return localStorage.setItem(tokenTableName, token)
  //   }
  // } else {
  return localStorage.setItem(`${tenantCode}_token`, token)
  // }
}

/**
 * @description 移除token
 * @returns {void|Promise<void>}
 */
export function removeToken() {
  // if (storage) {
  //   if ('localStorage' === storage) {
  //     return localStorage.removeItem(tokenTableName)
  //   } else if ('sessionStorage' === storage) {
  //     return sessionStorage.clear()
  //   } else {
  //     return localStorage.removeItem(tokenTableName)
  //   }
  // } else {
  return localStorage.removeItem(`${tenantCode}_token`)
  // }
}
